import {
  ADD_USER_PAYOUT_CONDITIONS,
  GET_USER_PAYOUT_CONDITIONS,
  SET_USER_PAYOUT_CONDITIONS,
  DELETE_USER_PAYOUT_CONDITIONS,
  UPDATE_USER_PAYOUT_CONDITIONS,
  LOADER_USER_PAYOUT_CONDITIONS
} from "./actionTypes";

export const addUserPayoutConditions = (user_id, data) => ({
  type: ADD_USER_PAYOUT_CONDITIONS,
  payload: { user_id, data }
})

export const getUserPayoutConditions = (data) => ({
  type: GET_USER_PAYOUT_CONDITIONS,
  payload: data
})

export const setUserPayoutConditions = (data) => ({
  type: SET_USER_PAYOUT_CONDITIONS,
  payload: data
})

export const updateUserPayoutConditions = (user_id, id, data) => ({
  type: UPDATE_USER_PAYOUT_CONDITIONS,
  payload: { user_id, id, data }
})

export const deleteUserPayoutConditions = (user_id, id) => ({
  type: DELETE_USER_PAYOUT_CONDITIONS,
  payload: { user_id, id}
})

export const loaderUserPayoutConditions = () => ({
  type: LOADER_USER_PAYOUT_CONDITIONS
})
